import { connect } from "react-redux";
import * as ContentContainer from "@common/components/src/common/components/content/ContentContainer";
import ContentView from "./ContentView";

export default connect(
    ContentContainer.mapStateToProps,
    ContentContainer.mapDispatchToProps
)(ContentView);
